import { find } from 'lodash';
import { useMemo } from 'react';

import accountsResource, { AccountType } from 'src/actions/accounts/accountsResource';
import { useResourceValues } from 'src/presentation/hooks/useResource';

type ChatRocketInformation = {
  accountId: string;
};

const useChatRocketAccount = () => {
  const { values: accounts } = useResourceValues(accountsResource);

  return useMemo<ChatRocketInformation | null>((): any => {
    const chatRocketAccount = find(accounts, { type: AccountType.ChatRocket });

    if (!chatRocketAccount) {
      return null;
    }

    return {
      accountId: chatRocketAccount.id,
    };
  }, [accounts]);
};

export default useChatRocketAccount;
